// emptyObserverCreator ensures we do not subscribe to broadcasts or broadcast
// deletes for a given resource
export default function emptyObserverCreator() {
  return () => {
    return {};
  };
}
